export function read(key) {
    try {
        return JSON.parse(localStorage.getItem(key) || 'null');
    } catch {
        return null;
    }
}

export function write(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
}
